<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<div [formGroup]="dataForm" class="form-container">
  <div class='flex-layout-row flex-layout-align-start-center flex-layout-gap-10px'>
    <div class="option-list">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ listItemTypeDisplay }}</mat-label>
        <input #trigger="matAutocompleteTrigger" matInput [formControl]="lookup" [matAutocomplete]="autoList" placeholder="Select {{ listItemTypeDisplay }}..." />
        <mat-autocomplete #autoList="matAutocomplete" [displayWith]="displaySelectedItem">
          <mat-option *ngFor="let lookup of filteredOptions | async" [value]="lookup">
            <ng-container *ngTemplateOutlet="customResultTemplate; context: { $implicit: lookup }"> </ng-container>
            <span *ngIf="!customResultTemplate">{{ lookup.itemName }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <button [disabled]="!canAddOption()" mat-icon-button (click)="add()" title="{{ addIconTitle }}">
        <mat-icon>add</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="listHasItems()">
    <div class="mat-mdc-header-cell">{{ listHeader }}</div>
    <div *ngFor="let item of visibleSelectedItems" class='flex-layout-row flex-layout-align-start-center flex-layout-gap-10px'>
      <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
      <div *ngIf="!hasTemplate">{{ item.itemName }}</div>
      <button mat-icon-button (click)="remove(item.itemId)" class="remove-icon" title="{{ deleteIconTitle }}">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <div *ngIf="!listHasItems()" class="table-no-items">{{ noItemsToDisplayMessage }}</div>
</div>
